import request from '../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../types/enums/request-enums';
import { CreateAIGenerationTypeRequest, UpdateAIGenerationTypeRequest } from '../../types/AIGenerationType';

const CreateAIGenerationType = (data: CreateAIGenerationTypeRequest): Promise<any> =>
    request({
        url: ApiURL.Command.StudioCommandURLs.AIGenerationTypeCommandURL.PostAIGenerationType,
        method: RequestType.POST,
        data,
    });

const UpdateAIGenerationType = (id: number, data: UpdateAIGenerationTypeRequest): Promise<any> =>
    request({
        url: `${ApiURL.Command.StudioCommandURLs.AIGenerationTypeCommandURL.PutAIGenerationType}/${id}`,
        method: RequestType.PUT,
        data,
    });

const DeleteAIGenerationType = (id: number): Promise<any> =>
    request({
        url: `${ApiURL.Command.StudioCommandURLs.AIGenerationTypeCommandURL.DeleteAIGenerationType}/${id}`,
        method: RequestType.DELETE,
    });

export const AIGenerationTypeCommand = {
    CreateAIGenerationType,
    UpdateAIGenerationType,
    DeleteAIGenerationType,
};

export default AIGenerationTypeCommand;

